// Race any promise against a hard timeout. Supabase queries can occasionally
// hang indefinitely (mid token-refresh, dead socket the SW is holding open,
// extension blocking the fetch). Without this, retry loops never get a
// chance to fire and the UI sits on a spinner forever.
//
// Usage:
//   const { data, error } = await withTimeout(
//     supabase.from('tenants').select('*').eq('id', id).maybeSingle(),
//     8000,
//     'tenant fetch'
//   )
export function withTimeout<T>(p: PromiseLike<T>, ms: number, label = 'request'): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    const t = setTimeout(() => reject(new Error(`${label} timed out (${ms}ms)`)), ms)
    Promise.resolve(p).then(
      v => { clearTimeout(t); resolve(v) },
      e => { clearTimeout(t); reject(e) },
    )
  })
}
